import React from "react";
import {
  UncontrolledDropdown,
  DropdownMenu,
  DropdownItem,
  DropdownToggle,
} from "reactstrap";
import axios from "axios";
import * as Icon from "react-feather";
import { connect } from "react-redux";
import { logoutUser } from "../../../redux/actions/auth/loginActions";
import LogoutModel from "../../../views/pages/model/LogoutModel";
const UserDropdown = (props) => {
  return (
    <DropdownMenu right>
      {/* <DropdownItem tag="a" href="#">
        <Icon.User size={14} className="mr-50" />
        <span className="align-middle">Edit Profile</span>
      </DropdownItem> */}
      {/* {/ <DropdownItem divider /> /} */}
      <DropdownItem
        tag="a"
        onClick={() => {
          props.logoutUser();
        }}
      >
        <Icon.Power size={14} className="mr-50" />
        <span className="align-middle">Log Out</span>
      </DropdownItem>
    </DropdownMenu>
  );
};

class NavbarUser extends React.PureComponent {
  static getDerivedStateFromProps(props, state) {
    console.log("555", props);
    if (props.user != null && (props.user.first_name || props.user.last_name || props.user.name)) {
      let first_name = props.user.first_name;
      let last_name = props.user.last_name;
      if (!first_name && props.user.name) {
        const parts = props.user.name.split(" ");
        first_name = parts[0];
        last_name = parts.slice(1).join(" ");
      }
      return {
        first_name: first_name || "",
        last_name: last_name || "",
        user_type: props.user.user_type || state.user_type,
      };
    }
    return null;
  }

  state = (() => {
    let initialUser = {};
    try {
      initialUser = JSON.parse(localStorage.getItem("User") || "{}");
    } catch (e) {
      console.error(e);
    }
    let first_name = initialUser.first_name;
    let last_name = initialUser.last_name;
    if (!first_name && initialUser.name) {
      const parts = initialUser.name.split(" ");
      first_name = parts[0];
      last_name = parts.slice(1).join(" ");
    }
    return {
      first_name: first_name || "",
      last_name: last_name || "",
      user_type: initialUser.user_type || "",
      navbarSearch: false,
      suggestions: [],
      logOutModelShow: false
    };
  })();

  componentDidMount() {
    axios.get("/api/main-search/data").then(({ data }) => {
      this.setState({ suggestions: data.searchResult });
    });
  }
  componentDidUpdate() {
    console.log("name", this.state);
  }

  handleNavbarSearch = () => {
    this.setState({
      navbarSearch: !this.state.navbarSearch,
    });
  };

  render() {
    console.log("hello5", this)
    return (
      <ul className="nav navbar-nav navbar-nav-user float-right">
        <div className="re-top_nave_block">
          <div><Icon.User size={14} /></div>
          <div className="re-top_nave_userdetail">
            <div style={{fontWeight:"600"}}>{this.state.first_name} {this.state.last_name}</div>
            <div style={{fontWeight:"600",color:"#e0e0e0ff",fontSize:"12px"}}>Private Driver AS - Ride Flex</div>
          </div>
        </div>
        <div className="re-top_nave_Login_block">
          {/* <div style={{fontWeight:"600",fontSize:"12px"}}>Help</div> */}
          <div
          style={{fontWeight:"600",fontSize:"12px",cursor:"pointer"}}
            onClick={() => {
              // this.props.logoutUser();
              this.setState({ logOutModelShow: true })
            }}
          >Logout</div>
        </div>
        <LogoutModel
          isOpen={this.state.logOutModelShow}
          close={()=>{
            this.setState({ logOutModelShow: false })
          }}
          logutUser={()=>{
            this.props.logoutUser()
          }}
          // logutUser={this.props.logoutUser}
        />
        {/* <UncontrolledDropdown tag="li" className="dropdown-user nav-item">
          <DropdownToggle tag="a" className="nav-link dropdown-user-link"> */}
        {/* <div className="user-nav d-sm-flex d-none">
              <span className="user-name text-bold-600">
                {this.state.first_name} {this.state.last_name}
              </span>
              <span className="user-status">{this.state.user_type}</span>
            </div> */}
        {/* <span data-tour="user">
              <img
                src={this.props.userImg}
                className="round"
                height="40"
                width="40"
                alt="avatar"
              />
            </span> */}
        {/* {/ {/ </DropdownToggle> */}
        <UserDropdown {...this.props} />
        {/* {/ </UncontrolledDropdown>  /}  */}
      </ul>
    );
  }
}
const mapStateToProps = (state) => ({
  user: state.auth.login.values,
  errors: state.errors,
});
export default connect(mapStateToProps, { logoutUser })(NavbarUser);